/**
 * 宝镁计划状态
 */
export const BM_PLAN_STATUS = {
  PENDING: {
    label: '执行中',
    value: 0,
    tagType: 'primary'
  },
  // EXECUTING: {
  //   label: '执行中',
  //   value: 2,
  //   tagType: 'primary'
  // },
  COMPLETED: {
    label: '已完成',
    value: 3,
    tagType: 'success'
  }
}
/**
 * 宝镁计划配载状态
 */
export const BM_PLAN_DISPATCH_STATUS = {
  PENDING: {
    label: '待配载',
    value: 0,
    tagType: 'primary'
  },
  TRANSFERRED: {
    label: '已被转移',
    value: 1,
    tagType: 'warning'
  },
  COMPLETED: {
    label: '已配载',
    value: 3,
    tagType: 'success'
  }
}

export const BM_PLAN_PLAN_STATUS = {
  HEAVY_WAIT_UNLOAD: {
    label: '重载待卸',
    value: '重载待卸',
  },
  HEAVY_UNLOADING: {
    label: '重载在卸',
    value: '重载在卸',
  },
  EMPTY_ON_THE_WAY: {
    label: '空船在途',
    value: '空船在途',
  },
  WAIT_LOAD: {
    label: '到港待装',
    value: '到港待装',
  },
  LOADING: {
    label: '在装',
    value: '在装',
  },
  LOADED: {
    label: '装妥',
    value: '装妥',
  }
}

/**
 * 宝镁航次状态
 */
export const BM_VOYAGE_STATUS = {
  PENDING_CONFIRM: {
    label: '待确认',
    value: 0,
    tagType: 'primary'
  },
  OWNER_ADJUSTING: {
    label: '船东调整',
    value: 1,
    tagType: 'warning',
    bgColor: '#E8F5FF'
  },
  OWNER_ABANDONED: {
    label: '船东放弃',
    value: 2,
    tagType: 'danger',
    bgColor: '#FFE6E6'
  },
  CONFIRMED: {
    label: '已确认',
    value: 3,
    tagType: 'primary'
  },
  EXECUTING: {
    label: '执行中',
    value: 4,
    tagType: 'primary'
  },
  COMPLETED: {
    label: '已完成',
    value: 5,
    tagType: 'success'
  }
}

/**
 * 宝镁航次动态节点
 */
export const BM_VOYAGE_NODE = {
  /** 到装港 */
  ARRIVE_LOAD_PORT: {
    label: '到装港',
    value: '10_ARRIVE_LOAD_PORT'
  },
  /** 开装 */
  OPEN_LOAD: {
    label: '开装',
    value: '20_OPEN_LOAD'
  },
  /** 离装港 */
  LEAVE_LOAD_PORT: {
    label: '离装港',
    value: '30_LEAVE_LOAD_PORT'
  },
  /** 到卸港 */
  ARRIVE_UNLOAD_PORT: {
    label: '到卸港',
    value: '40_ARRIVE_UNLOAD_PORT'
  },
  /** 开卸 */
  OPEN_UNLOAD: {
    label: '开卸',
    value: '50_OPEN_UNLOAD'
  },
  /** 离卸港 */
  LEAVE_UNLOAD_PORT: {
    label: '离卸港',
    value: '60_LEAVE_UNLOAD_PORT'
  }
}

/**
 * 船舶作业状态
 */
export const SHIP_WORK_STATUS = {
  EMPTY_WAIT: {
    label: '空船待装',
    value: 0
  },
  LOADING_WAIT: {
    label: '已配待装',
    value: 1
  },
  UNLOADING_WAIT: {
    label: '已装待卸',
    value: 2
  },
}

/**
 * 船舶队列颜色标记
 */
export const SHIP_QUEUE_COLOR_MARK = {
  GREEN: {
    label: '绿',
    desc: '一定可以装',
    bgColor: '#E6F7EF',
    value: 0
  },
  YELLOW: {
    label: '黄',
    desc: '预计可以装',
    bgColor: '#FFF7E6',
    value: 10
  },
  LIGHT_BLUE: {
    label: '浅蓝',
    desc: '当前计划中手动移出',
    bgColor: '#E8F4FF',
    value: 15
  },
  RED: {
    label: '红',
    desc: '一定不能装',
    bgColor: '#FFF1F0',
    value: 20
  },
  GRAY: {
    label: '灰',
    desc: '请假中',
    bgColor: '#F5F5F5',
    value: 30
  },
}

// 宝镁费用状态
export const BM_COST_STATUS = {
  PEND_SUBMIT: {
    label: '待提交',
    value: 0
  },
  PEND_AUDIT: {
    label: '待审核',
    value: 1
  },
  AUDIT_PASS: {
    label: '审核通过',
    value: 2
  },
  AUDIT_REJECT: {
    label: '审核驳回',
    value: 3
  }
}
/**
 * 收入支出方向
 * @enum {Object}
 * @description 收入支出方向
 * @readonly
 */
export const INCOME_EXPEND_DIRECTION = {
  /** 收入 */
  INCOME: {
    label: '收入',
    value: 1
  },
  /** 支出 */
  EXPEND: {
    label: '支出',
    value: -1
  }
}

// 其他费用类型
export const SHIP_REWARDS_COST_TYPES = {
  AWARD: {
    label: '奖励',
    value: 1
  },
  FINE: {
    label: '惩罚',
    value: 2
  },
  FEE: {
    label: '费用',
    value: 3
  }
}


// 发布
export const PublishStatus = {
  UNPUBLISHED: {
    label: '未发布',
    value: 0
  },
  PUBLISHED: {
    label: '已发布',
    value: 1
  }
}
// 激活
export const ActivityStatus = {
  INACTIVE: {
    label: '未激活',
    value: 0
  },
  ACTIVE: {
    label: '已激活',
    value: 1
  }
}


export const PaymentGroupType={
  FREIGHT: {
    label: '运费',
    value: 10
  },
  FUEL: {
    label: '加油费',
    value: 20
  },
  OTHER: {
    label: '其他费用',
    value: 30
  },
  BM_SHIP: {
    label: '宝镁船舶账单',
    value: 40
  },
  BM_PORT: {
    label: '宝镁港口费用',
    value: 50
  }
}


// 字典 分类DEFAULT_VALUE  ,TAIL_DIFF_PRICE
export const DICT_VALUE = {
  TAIL_DIFF_PRICE: {
    label: '尾差核销金额',
    value: 'TAIL_DIFF_PRICE'
  },
  DEFAULT_VALUE: {
    label: '字典值',
    value: 'DEFAULT_VALUE'
  }
}

export const BM_MONTH_PLAN = {
  // 月度计划总生产量
  // 月度计划销售贸易量（贸易商）
  // 月度宝武体系钢厂发货量（需要我司安排江船请明确时间）
  // 月度童埠港水水倒驳总量
  // 月度童埠港总直发量
  MONTH_TOTAL: {
    label: '月度计划总生产量',
    value: 'MONTH_TOTAL',
    min: 100,
  },
  MONTH_PART_SALE: {
    label: '月度计划销售贸易量（贸易商）',
    value: 'MONTH_PART_SALE',
    min: 200,
  },
  MONTH_PART_BWGC: {
    label: '月度宝武体系钢厂发货量（需要我司安排江船请明确时间）',
    value: 'MONTH_PART_BWGC',
    min: 300,
  },
  MONTH_PART_SHIP_SHIP: {
    label: '月度童埠港水水倒驳总量',
    value: 'MONTH_PART_TONGHUA',
    min: 400,
  },
  MONTH_PART_SHIP_DIRECT: {
    label: '月度童埠港总直发量',
    value: 'MONTH_PART_SHIP_DIRECT',
    min: 500,
  },
}

/**
 * 单价规则类型
 */
export const UNIT_EXPRESSION_GROUP_TYPE = {
  /**
   * 运价
   */
  FREIGHT: {
    label: '运价',
    value: 0
  },
  /**
   * 航次补贴
   */
  SUBSIDY: {
    label: '航次补贴',
    value: 1
  },
}